import {
  SET_SYSTEM_COMM_VERSION,
  SET_SYSTEM_DISABLE_COMM_UPDATER,
  SET_SYSTEM_INFO,
  SET_SYSTEM_THEME,
  SET_SYSTEM_TRIAL_NOTICE_VISIBLE,
  SET_SYSTEM_WIDE_SCREEN,
} from '../constants/SystemConstants';

export function setSystemInfo(info) {
  return {
    type: SET_SYSTEM_INFO,
    payload: info,
  };
}

export function setSystemTrialNoticeVisible(visible) {
  return {
    type: SET_SYSTEM_TRIAL_NOTICE_VISIBLE,
    payload: visible,
  };
}

export function setCommVersion(version) {
  return {
    type: SET_SYSTEM_COMM_VERSION,
    payload: version,
  };
}

export function setDisableCommUpdater(disable) {
  return {
    type: SET_SYSTEM_DISABLE_COMM_UPDATER,
    payload: disable,
  };
}

export function setTheme(theme) {
  return {
    type: SET_SYSTEM_THEME,
    payload: theme,
  };
}

export function setWideScreen(wide) {
  return {
    type: SET_SYSTEM_WIDE_SCREEN,
    payload: wide,
  };
}
